import React from 'react';
import { motion } from "framer-motion";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, staggerChildren: 0.1 } 
    }
  };

  return (
    <footer className="legal-footer">
      <motion.div 
        className="legal-footer-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={footerVariants}
      >
        <div className="legal-footer-grid">
          {/* Brand Column */}
          <div className="legal-footer-column brand">
            <h2 className="legal-footer-logo">DHANUSHDHARI</h2>
            <p className="legal-footer-about">
              Empowering individuals and businesses with AI-driven legal intelligence. 
              Precision, integrity, and innovation in every document.
            </p>
            <div className="legal-footer-socials">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><FaInstagram /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="legal-footer-column">
            <h3 className="legal-footer-heading">Quick Links</h3>
            <ul className="legal-footer-links">
              <li><a href="#features">Features</a></li>
              <li><a href="#practice-areas">Practice Areas</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
            </ul>
          </div>

          {/* Support */}
          <div className="legal-footer-column">
            <h3 className="legal-footer-heading">Support</h3>
            <ul className="legal-footer-links">
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Contact Support</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="legal-footer-column">
            <h3 className="legal-footer-heading">Get In Touch</h3>
            <ul className="legal-footer-contact">
              <li>Email: contact@dhanushdhari.com</li>
              <li>Phone: +1 (555) 000-0000</li>
              <li>Address: 123 Legal Plaza, Suite 100, NY</li>
            </ul>
          </div>
        </div>

        <div className="legal-footer-bottom">
          <p>&copy; {currentYear} Dhanushdhari Legal Advisory. All rights reserved.</p>
          {/* <div className="legal-footer-disclaimer">
            Disclaimer: Dhanushdhari is an AI tool and does not constitute formal legal advice or a lawyer-client relationship.
          </div> */}
        </div>
      </motion.div>
    </footer>
  );
}

export default Footer;